import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  card: {
    width: "50%",
    maxWidth: "50%",

    background: "transparent",

    border: `1px solid ${
      theme.colorScheme === "dark"
        ? theme.colors.dark[5]
        : theme.colors.gray[2]
    }`,

    borderRadius: theme.radius.md,

    transition: "box-shadow .2s ease, border-color .2s ease",

    "&:hover": {
      boxShadow: theme.shadows.sm,
    },

    [`@media (max-width: ${theme.breakpoints.sm}px)`]: {
      width: "100%",
      maxWidth: "100%",
    },
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 24px",

    borderBottom: `1px solid ${
      theme.colorScheme === "dark"
        ? theme.colors.dark[5]
        : theme.colors.gray[2]
    }`,
  },

  title: {
    fontWeight: 600,
    fontSize: theme.fontSizes.lg,
    color:
      theme.colorScheme === "dark"
        ? theme.white
        : theme.black,
  },

  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.lg,
  },

  divider: {
    width: 1,
    height: 26,
    marginLeft: theme.spacing.xs,
    marginRight: theme.spacing.xs,
    background:
      theme.colorScheme === "dark"
        ? theme.colors.dark[4]
        : theme.colors.gray[3],
  },

  row: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    minHeight: 72,

    padding: "20px 24px",

    "&:not(:last-child)::after": {
      content: '""',
      position: "absolute",
      left: 24,
      right: 24,
      bottom: 0,
      height: 1,
      background:
        theme.colorScheme === "dark"
          ? theme.colors.dark[5]
          : theme.colors.gray[2],
    },
  },

  iconContainer: {
    width: 40,
    height: 40,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,

    borderRadius: theme.radius.md,

    background:
      theme.colorScheme === "dark"
        ? theme.colors.dark[6]
        : theme.colors.gray[0],

    color:
      theme.colorScheme === "dark"
        ? theme.colors.gray[4]
        : theme.colors.gray[6],

    marginRight: theme.spacing.md,
  },

  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },

  label: {
    fontSize: theme.fontSizes.sm,
    fontWeight: 400,
    lineHeight: 1.4,
    color:
      theme.colorScheme === "dark"
        ? theme.colors.gray[5]
        : theme.colors.gray[6],
  },

  value: {
    fontWeight: 600,
    fontSize: theme.fontSizes.md,
    lineHeight: 1.5,
    wordBreak: "break-word",

    color:
      theme.colorScheme === "dark"
        ? theme.white
        : theme.black,
  },

  status: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },

  dot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    background: theme.colors.green[6],
  },

  dotDisabled: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    background: theme.colors.red[6],
  },

  editButton: {
    color: theme.colors.green[6],
    background: "transparent",

    "&:hover": {
      background:
        theme.colorScheme === "dark"
          ? theme.colors.dark[5]
          : theme.colors.green[0],
    },
  },

  deleteButton: {
    color: theme.colors.red[6],
    background: "transparent",

    "&:hover": {
      background:
        theme.colorScheme === "dark"
          ? theme.colors.dark[5]
          : theme.colors.red[0],
    },
  },
}));

